import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiConfirmationOpenEnrollmentQueryResponse,
  GetApiConfirmationOpenEnrollmentQueryParams,
  GetApiConfirmationOpenEnrollment401,
  GetApiConfirmationOpenEnrollment403,
} from "../../../types/GetApiConfirmationOpenEnrollment";

export function getGetApiConfirmationOpenEnrollmentUrl() {
  return `/api/Confirmation/open-enrollment` as const;
}

/**
 * {@link /api/Confirmation/open-enrollment}
 */
export async function getApiConfirmationOpenEnrollment(
  params?: GetApiConfirmationOpenEnrollmentQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiConfirmationOpenEnrollmentQueryResponse,
    ResponseErrorConfig<
      GetApiConfirmationOpenEnrollment401 | GetApiConfirmationOpenEnrollment403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiConfirmationOpenEnrollmentUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
